import actions from "@/store/campaign/actions";
import state from "@/store/campaign/states";
import mutations from "@/store/campaign/mutations";

const CampaignModule = {
  namespaced: true,
  actions,
  state,
  mutations,
};

export default CampaignModule;